import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'

export const useIsTrial = (): boolean => {
  const { currentSubscriptionData } = useSelector((state: RootState) => state.location)

  return currentSubscriptionData?.value?.plan === 'trial'
}
